module.exports = __webpack_public_path__ + "img/x5.eca97576.jpg";